/**
 * Create the store with dynamic reducers
 */

import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "connected-react-router";
import createSagaMiddleware from "redux-saga";
import { createInjectorsEnhancer } from "redux-injectors";

import globalSaga from "scenes/saga";
import createReducer from "./reducers";
import { onSagaError } from "./utils/sagaErrorHandler";

export default function configureStore<C extends {}>(
  initialState,
  history,
  context?: C
) {
  let composeEnhancers = compose;
  const reduxSagaMonitorOptions = {
    onError: onSagaError,
    context,
  };

  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);

  // Create the store with two middlewares
  // 1. sagaMiddleware: Makes redux-sagas work
  // 2. routerMiddleware: Syncs the location/URL path to the state
  let middlewares = [sagaMiddleware, routerMiddleware(history)];

  // If Redux Dev Tools and Saga Dev Tools Extensions are installed, enable them

  /* istanbul ignore next */
  if (
    /* process.env.NODE_ENV !== 'production' && */
    typeof window === "object"
  ) {
    /* @ts-ignore eslint-disable no-underscore-dangle */
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      // @ts-ignore
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
    }

    // NOTE: Uncomment the code below to restore support for Redux Saga
    // Dev Tools once it supports redux-saga version 1.x.x
    // if (window.__SAGA_MONITOR_EXTENSION__)
    //   reduxSagaMonitorOptions = {
    //     sagaMonitor: window.__SAGA_MONITOR_EXTENSION__,
    //   };

    /* eslint-enable */

    // Enable redux logger when in dev mode
    import("redux-logger").then((reduxLogger) => {
      middlewares = [...middlewares, reduxLogger.logger];
    });
  }

  const enhancers = [
    applyMiddleware(...middlewares),
    createInjectorsEnhancer({
      createReducer,
      runSaga: sagaMiddleware.run,
    }),
  ];

  const store = createStore(
    createReducer(),
    initialState,
    composeEnhancers<any>(...enhancers)
  );

  sagaMiddleware.run(globalSaga);

  return store;
}
